import script from "./AppMenu.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenu.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./AppMenu.vue3.vue?vue&type=style&index=0&id=037edda4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037edda4"]])

export default __exports__